import { render, staticRenderFns } from "./TerminalAuthorizationDetail.vue?vue&type=template&id=61ab6c56&scoped=true&"
import script from "./TerminalAuthorizationDetail.vue?vue&type=script&lang=js&"
export * from "./TerminalAuthorizationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ab6c56",
  null
  
)

export default component.exports